var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourthImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 7H7C5.067 7 3.5 8.567 3.5 10.5V31.5C3.5 33.433 5.067 35 7 35H35C36.933 35 38.5 33.433 38.5 31.5V10.5C38.5 8.567 36.933 7 35 7Z",
    fill: "url(#paint0_linear_232_88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14H38.5V17.5H3.5V14ZM8.75 28C8.75 28.4641 8.93437 28.9092 9.26256 29.2374C9.59075 29.5656 10.0359 29.75 10.5 29.75H17.5C17.9641 29.75 18.4092 29.5656 18.7374 29.2374C19.0656 28.9092 19.25 28.4641 19.25 28C19.25 27.5359 19.0656 27.0908 18.7374 26.7626C18.4092 26.4344 17.9641 26.25 17.5 26.25H10.5C10.0359 26.25 9.59075 26.4344 9.26256 26.7626C8.93437 27.0908 8.75 27.5359 8.75 28Z",
    fill: "#444444"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_232_88",
    x1: 21,
    y1: 7,
    x2: 21,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthImage);
export default __webpack_public_path__ + "static/media/fourthImage.4691f8e7b6857438d6ee4f7cd94e9083.svg";
export { ForwardRef as ReactComponent };